import { CoreFieldProps, fieldTypes } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";
import { LawFirmOrganizationAccountRiskReview } from "@/types/LawFirmOrganizationAccountRiskReview";

export interface LawFirmOrganizationAccountRiskReviewComplexFieldProps
  extends fieldTypes.BaseFieldProps<LawFirmOrganizationAccountRiskReview> {}

export const LawFirmOrganizationAccountRiskReviewComplexField: FC<
  LawFirmOrganizationAccountRiskReviewComplexFieldProps
> = (props) => {
  return (
    <section className="complex-field-container risk-review">
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.ACCEPTABLE_BUSINESS
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.LOCATION}
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BANKRUPTCY}
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BALANCE_EVER_BELOW_ZERO
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BAR_DISCIPLINARY_ACTION
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.TIMES_ACCOUNT_OVERDRAWN
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.NEGATIVE_SOCIAL_MEDIA_CHECK
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
      </div>
    </section>
  );
};
